import { httpGet, httpPost } from '../utils/cms-axios';

export async function getTemplateCodeV2({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/template/chat/${chat_token}/v2/get_code`, {
    headers: {
      Authorization: `Bearer ${cms_token}`,
    },
  });
  if (!res.ok) {
    throw new Error(`getTemplateCodeV2 failed: ${res.status}`);
  }
  return res.json();
}

export function getAiSaver() {
  return httpGet("/ai-api-saver-address", {}, {}, "");
}

export function createChatTokenSimple(data) {

  const {site_id, address, token} = data

  return httpPost("/chat/create_token", {
    "site_id": site_id,
  }, {
    "Authorization": `Bearer ${token}`,
  }, `${address}`);
}

export function createChatTokenTemplateSimple(data) {

  const {site_id, address, token, page_pkg_code, template_pkg_code, page_type, is_list_page, template_page_id, template_layout_code} = data

  return httpPost("/template/chat/create_token", {
    "site_id": site_id,
    "page_pkg_code": page_pkg_code,
    "template_pkg_code": template_pkg_code,
    "page_type": page_type,
    "is_list_page": is_list_page,
    "template_page_id": template_page_id,
    "template_layout_code": template_layout_code,
  }, {
    "Authorization": `Bearer ${token}`,
  }, `${address}`);
}

export function createChatTokenConfigSimple(data) {

  const {site_id, address, token} = data

  return httpPost("/config/chat/create_token", {
    "site_id": site_id,
  }, {
    "Authorization": `Bearer ${token}`,
  }, `${address}`);
}

export function getSiteConfig(data) {
  const {address, chat_token, cms_token} = data

  return httpGet(`/config/chat/${chat_token}/get_site_config`, {}, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function getTemplateCode(data) {

  const {address, chat_token, cms_token} = data

  return httpGet(`/template/chat/${chat_token}/get_code`, {}, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function commitCreateDoc(data) {

    const {address, chat_token, cms_token, doc} = data

    return httpPost(`/template/chat/${chat_token}/commit_doc`, {
      "doc": doc,
    }, {
      "Authorization": `Bearer ${cms_token}`,
    }, `${address}`);
}

export function createSummary(data) {

  const {address, cms_token, site_id, post_type_id, post_data} = data

  return httpPost(`/tool/post/create_summary`, {
    "site_id": site_id,
    "post_type_id": post_type_id,
    "post_data": post_data,
  }, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function createTextGrammar(data) {
  const {address, cms_token, text} = data

  return httpPost(`/tool/text_grammar/check`, {
    "text": text,
  }, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function createImage(data) {
  const {address, cms_token, site_id, post_type_id, post_data, image_style} = data

  return httpPost(`/tool/post_create_images/create_image`, {
    "site_id": site_id,
    "post_type_id": post_type_id,
    "post_data": post_data,
    "image_style": image_style, // 画像スタイルパラメータを追加
  }, {
    "Authorization": `Bearer ${cms_token}`,
  }, `${address}`);
}

export function createQAFromText(data) {
  const {address, cms_token, site_id, text} = data

  return httpPost(`/tool/qa_generation/run-text`, {
    "data": text,
  }, {
    "Authorization": `Bearer ${cms_token}`,
    "SiteId": site_id,
  }, `${address}`);
}


export function createQATask(data) {
  const {address, cms_token, site_id, name} = data;

  return httpPost('/tool/qa_generation/task/create', {
    name,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function uploadQATaskFile(data) {
  const {address, cms_token, site_id, task_id, file} = data;
  
  const formData = new FormData();
  formData.append('task_id', task_id);
  formData.append('file', file);
  
  return httpPost('/tool/qa_generation/task/upload', 
    formData, 
    {
      'Authorization': `Bearer ${cms_token}`,
      'SiteId': site_id,
      'Content-Type': 'multipart/form-data',
    }, 
    `${address}`,
    true // formDataフラグ
  );
}

export function startQATask(data) {
  const {address, cms_token, site_id, task_id} = data;

  return httpPost('/tool/qa_generation/task/start', {
    task_id,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function getQATaskDetails(data) {
  const {address, cms_token, site_id, task_id} = data;

  return httpGet(`/tool/qa_generation/task/${task_id}`, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function getQATaskList(data) {
  const {address, cms_token, site_id, limit, last_doc_id} = data;
  
  let url = '/tool/qa_generation/tasks/list';
  const params = [];
  
  if (limit !== undefined) {
    params.push(`limit=${limit}`);
  }
  
  if (last_doc_id !== undefined) {
    params.push(`last_doc_id=${last_doc_id}`);
  }
  
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return httpGet(url, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function deleteQATaskFile(data) {
  const {address, cms_token, site_id, task_id, file_name} = data;

  return httpPost('/tool/qa_generation/task/delete-file', {
    task_id,
    file_name,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function getQAList(data) {
  const {address, cms_token, site_id, task_id, limit, last_doc_id, source, status} = data;
  
  let url = `/tool/qa_generation/qa/list`;
  const params = [`task_id=${task_id}`];
  
  if (limit !== undefined) {
    params.push(`limit=${limit}`);
  }
  
  if (last_doc_id !== undefined) {
    params.push(`last_doc_id=${last_doc_id}`);
  }
  
  if (source !== undefined) {
    params.push(`source=${source}`);
  }
  
  if (status !== undefined) {
    params.push(`status=${status}`);
  }
  
  url += `?${params.join('&')}`;

  return httpGet(url, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function exportQAListCSV(data) {
  const {address, cms_token, site_id, task_id, source, status} = data;
  
  let url = `/tool/qa_generation/qa/export-csv`;
  const params = [`task_id=${task_id}`];
  
  if (source !== undefined) {
    params.push(`source=${source}`);
  }
  
  if (status !== undefined) {
    params.push(`status=${status}`);
  }
  
  url += `?${params.join('&')}`;

  return httpGet(url, {}, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`, true); // blobフラグをtrueに設定
}

export function importQAListCSV(data) {
  const {address, cms_token, site_id, task_id, file} = data;
  
  const formData = new FormData();
  formData.append('task_id', task_id);
  formData.append('file', file);
  
  return httpPost('/tool/qa_generation/qa/import-csv', 
    formData, 
    {
      'Authorization': `Bearer ${cms_token}`,
      'SiteId': site_id,
      'Content-Type': 'multipart/form-data',
    }, 
    `${address}`,
    true // formDataフラグ
  );
}

export function updateQA(data) {
  const {address, cms_token, site_id, qa_id, task_id, question, answer, status, post_type_id, post_id} = data;
  
  return httpPost('/tool/qa_generation/qa/update', {
    qa_id,
    task_id,
    question,
    answer,
    status,
    post_type_id,
    post_id,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function updateQAStatuses(data) {
  const {address, cms_token, site_id, qa_ids, task_id, status} = data;
  
  return httpPost('/tool/qa_generation/qa/update-statuses', {
    qa_ids,
    task_id,
    status,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

export function updateTemplateDoc(data) {
  const {address, cms_token, site_id, version} = data;
  
  return httpPost('/tool/template_doc/update', {
    version,
  }, {
    'Authorization': `Bearer ${cms_token}`,
    'SiteId': site_id,
  }, `${address}`);
}

// ---------------------------------------------------------------------------
// Design Editor Chat API
// ---------------------------------------------------------------------------

export function createDesignEditorChatToken(data) {
  const { site_id, address, token, template_pkg_code, page_pkg_code } = data;

  return httpPost('/design-editor/chat/create_token', {
    site_id,
    template_pkg_code,
    page_pkg_code,
  }, {
    'Authorization': `Bearer ${token}`,
  }, `${address}`);
}

export function listDesignEditorChatTokens(data) {
  const { site_id, template_pkg_code, address, token } = data;
  const url = `/design-editor/chat/list_tokens?site_id=${encodeURIComponent(site_id)}&template_pkg_code=${encodeURIComponent(template_pkg_code)}`;
  return httpGet(url, {}, { 'Authorization': `Bearer ${token}` }, `${address}`);
}

export async function getDesignEditorChatCode({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/design-editor/chat/${chat_token}/v3/get_code`, {
    headers: { Authorization: `Bearer ${cms_token}` },
  });
  if (!res.ok) throw new Error(`getDesignEditorChatCode failed: ${res.status}`);
  return res.json();
}

export async function getDesignEditorChatHistory({ address, chat_token, cms_token }) {
  const res = await fetch(`${address}/design-editor/chat/${chat_token}/v3/history/list`, {
    headers: { Authorization: `Bearer ${cms_token}` },
  });
  if (!res.ok) throw new Error(`getDesignEditorChatHistory failed: ${res.status}`);
  return res.json();
}
